import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.3 20.7L8.58 16H5a1 1 0 01-1-1V9a1 1 0 011-1h3.59l4.7-4.7A1 1 0 0115 4v16a1 1 0 01-1.7.7zM10.004 9.414L13 6.418v11.16l-3.009-2.995A2 2 0 008.58 14H6v-4h2.59a2 2 0 001.414-.586zm6.723-.346a1.011 1.011 0 00.102.101l.001.001a4 4 0 010 5.66 1 1 0 001.41 1.41 6.56 6.56 0 00.108-.11l.021-.023A5.98 5.98 0 0019.995 12a5.981 5.981 0 00-1.755-4.24 1.057 1.057 0 00-.102-.103 1 1 0 00-1.41 1.411z",
      fill: "#2d6ded"
    }
  )
), o = a;
export {
  o as default
};
